<template>
    <div class="underLogoPhrase">
        <h2 class="font-weight-bold mb-3 centers">Les Animaux trouvés</h2>

        <!-- Description de la fourrière -->
     
    </div>

    <div class="container-fluid">
         <p
            v-if="fourriereContent"
           style="text-align: center;font-size: 20px;"
            v-html="fourriereContent"
        ></p>
        <br>
        <br>

        <div class="row">
            <div
                class="col-lg-3"
                v-for="animau in animaux"
                :key="animau.id"
            >
                <div class="card" style="height: auto; min-height: 350px;">
                    <div>
                        <img
                            :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
                            :alt="'photo de l animal du SPA Tarbes | Bigorre - Hautes-Pyrénées ' + animau.type + ' ' + animau.name"
                            class="tailleimg"
                            :title="animau.name + ' ' + animau.race"
                        />
                    </div>

                    <div class="endessous" style="margin-top: 10px !important; margin-bottom: 30px;">
                        <h4 style="color:red">{{ animau.name }}</h4>
                        <h4 style="color:red">{{ animau.huge_information }}</h4>
                        <h4 style="color:red">{{ animau.ville }}</h4>
                        <h4 style="color:red">{{ formaterDate(animau.arrive) }}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            animaux: [],
            fourriereContent: null,
        };
    },
    mounted() {
        const idSite = this.$idSite;

        // Animaux en fourrière
        fetch(`https://admin.asso-refuge.fr/getFourriere/${idSite}`)
            .then(response => response.json())
            .then(data => {
                this.animaux = data;
            })
            .catch(error => {
                console.error('Il y a eu un problème avec votre requête :', error.message);
            });

        // Description de la fourrière
        fetch(`https://admin.asso-refuge.fr/getFourriereDescri/${idSite}`)
            .then(response => response.json())
            .then(data => {
                this.fourriereContent = data[0]?.content || null;
                
            })
            .catch(error => {
                console.error('Il y a eu un problème avec votre requête :', error.message);
            });
    },
    methods: {
        formaterDate(dateString) {
            if (!dateString) return 'Inconnu';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Inconnu';
            const options = { day: '2-digit', month: 'long', year: 'numeric' };
            return date.toLocaleDateString('fr-FR', options);
        },
    },
    watch: {
        '$route.query.type': 'appliquerFiltre',
    },
};
</script>
